import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import {
  About,
  Contact,
  CreateAccount,
  Download,
  EpisodePage,
  Home,
  MovieDetailsPage,
  Search,
  SignIn,
  TvShows,
  TvShowsDetailsPage,
} from "./pages";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    //    to={`/tvshows/${id}/${season_number}/${episode?.episode_number}`}
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:id" element={<MovieDetailsPage />} />
        <Route path="/tvshows/:id" element={<TvShowsDetailsPage />} />
        <Route
          path="/tvshows/:id/:season_number/:episode_number"
          element={<EpisodePage />}
        />
        <Route path="/about" element={<About />} />
        <Route path="/download" element={<Download />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/search/:searchTerm" element={<Search />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/tvshows" element={<TvShows />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
